<template>
  <div>
      <!-- 头部 -->
      <Headtow></Headtow>

      <div class="clear"></div>
      <div class="h-10"></div>
      <div id="w-center">
        <!-- <div id="Breadcrumb">
          <i class="el-icon-house Breadcrumb-i" ></i>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>图书列表</el-breadcrumb-item>
          </el-breadcrumb>
        </div> -->
        <!-- 左侧 -->
        <div class="w-center">
           <el-button
             style="float: right;margin-top: 10px;margin-right: 20px;"
             type="success"
             size="small"
             @click="xz"
             >下载</el-button
           >
          <div id="products_type" style="width: 90%;">
            <el-radio-group v-model="typeid" @change="type" size="medium">
                  <el-radio-button label="0" style="float: left;" >全部</el-radio-button>
                  <div style="width: 96%;float: left;">
                   <div v-for="(item, index) in types" :key="item.id" style="display: inline-block;width: 25%;">
                      <el-radio-button  :label="item.id" >{{item.title}}</el-radio-button>1
                   </div>
                 </div>

              </el-radio-group>


              <div v-if="orderlist !=''">
                <div class="h-20"></div>
                <!-- <el-radio-button  >反驳订单</el-radio-button>&nbsp;&nbsp; -->
                <el-radio-group v-model="radio" @change="radxz">
                    <el-radio label="0" >反驳订单</el-radio>
                    <el-radio  v-for="(item, index) in orderlist"  :label="item.ordernumber">{{item.ordernumber}}[{{item.create_time}}]</el-radio>
                </el-radio-group>
              </div>

              <div class="h-10"></div>
          </div>
          <ul id="products-content"  >
              <!-- <li v-for="(item, index) in list" :key="item.id">
                <router-link :to="{path:'/ProductsCont',query: {id: item.id}}">
                  <div class="products-content-left">
                      <img :src="item.picurl" alt="" lazy >
                  </div>
                  <div class="products-content-center">
                      <p class="products-content-center-title">{{item.title}}</p>
                      <p class="products-content-center-jianjie ov2">{{item.introduction}}</p>
                      <p class="products-content-center-bq">{{item.money}}</p>
                      <p class="products-content-center-gsmc  ov1">{{item.gsname}}</p>
                  </div>
                  <div class="clear"></div>
                </router-link>
               </li> -->
          </ul>


            <el-table
              :data="list"
              v-loading="loading"
              border
              style="width: 100%">
              <el-table-column
                prop="tm"
                label="书号"
                width="150">
              </el-table-column>
              <el-table-column
                prop="title"
                label="书名"
               >
              </el-table-column>
              <el-table-column
                prop="cbs"
                label="出版社"
                width="120">
              </el-table-column>

              <el-table-column
                prop="zz"
                label="作者"
                width="120">
              </el-table-column>

              <el-table-column
                prop="cbrq"
                label="出版日期"
                width="120">
              </el-table-column>

              <el-table-column
                prop="old_price"
                label="定价"
                width="120">
              </el-table-column>


              <el-table-column
                prop="ztfl"
                label="中图分类"
                >
              </el-table-column>

              <el-table-column
                prop="kb"
                label="开本"
                width="120">
              </el-table-column>

              <el-table-column

                prop="dzdx"
                label="读者对象"
                >
              </el-table-column>


              <el-table-column
                width="230">
                <template slot="header" slot-scope="scope">
                      <el-input
                        style="height: 32px;"
                        @change="handleInput"
                        v-model="search"
                        size="mini"
                        class="h-g"
                        @input="handleInput"
                        placeholder="输入关键字搜索[书名]"/>
                        <!-- <el-button
                          style="float: right;"
                          type="success"
                          size="small"
                          @click="ss"
                          >搜索</el-button
                        > -->


                      </template>

                <template slot-scope="scope">
                  <el-button @click="handleClick(scope.row,1)" type="danger" size="small">加入购物车</el-button>

                  <el-button v-if="orderlist !=''" @click="handleClick(scope.row,2)" type="warning" size="small">加入订单</el-button>
                </template>
              </el-table-column>
            </el-table>


          <div class="page">
            <!-- <el-pagination
              background
              layout="prev, pager, next"
              :page-size="12"
              :page-sizes="[100, 200, 300, 400]"
              @current-change="handleCurrentChange"
              :total="total">
            </el-pagination> -->

            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[20, 50,80,100]"
              :page-size="size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>


          </div>
        </div>
        <!-- 左侧结束 -->

      </div>

      <el-backtop :bottom="100">
          <div
            style="{
              height: 100%;
              width: 100%;
              background-color: #f2f5f6;
              box-shadow: 0 0 6px rgba(0,0,0, .12);
              text-align: center;
              line-height: 40px;
              color: #1989fa;
            }"
          >
            UP
          </div>
        </el-backtop>



      <Foot></Foot>
  </div>
</template>
<style >
    .seamless-warp2 {
        overflow: hidden;
        width: 998px;
        /* height: 200px; */
     }
    .index-tjcp-ul{width: 2220px;}
    .seamless-warp3 {
         overflow: hidden;
         width: 1200px;
         height: 70px;
     }
    /* .index-tjcp-ul1{width: 1716px;} */
</style><script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue'
export default{
  data(){
    return {
      radio:'0',
       search: '',
      loading:true,
      list:[],
      page:1,
      total:0,
      size:20,
      info:[],
      activeName: 'first',
      ptzc:'',
      tabPosition:'1',
      types:{},
      typeid:'0',

      typetwoid:'1',
      left:{},
      keywords:'',
      typetwo:[],
      orderlist:[],
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
     'Foot': foot,

  },
  mounted () {
    this.keywords = this.$route.query.keyword
    var typeid = this.$route.query.typeid
    if(typeid){
      this.typeid = typeid;
    }
    var typetwoid = this.$route.query.typetwoid
    if(typetwoid){
      this.typetwoid = typetwoid
    }
    console.log(this.keywords);
    this.recordapi();
  },
  methods:{

    xz(){
      if(this.typeid == 0){
           this.$message.error('请选择分类');
           return;
      }
       // console.log(process.env);
      var that = this;
      // console.log(process.env.API_HOST+'Goods_Classify/download?pid='+e);
        window.location=process.env.API_HOST+'Goods_Classify/download?pid='+this.typeid

    },

     handleSizeChange(val) {
       this.size = val
        console.log(val);
        this.recordapi();
      },



    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Goods_Classify/index",{'userid':userid,'typeid':that.typeid,'page':this.page,'keyword':this.keywords,'size':this.size}).then(res => {
          console.log(res);
          that.types= res.type;
          that.orderlist= res.orderlist;
          that.list= res.list.data;
          this.total = res.list.total

          this.loading = false
        });
    },

    handleClick(row,e) {
      if(e == 2){
        if(this.radio=='0'){
          this.$message.error('请选择订单');
          return;
        }
      }
      var that = this;
      var userid = that.$cookieStore.getCookie('userid');
      that.$api.post("/Goods/buy",{'gid':row['id'],'userid':userid,'status':'cart','gordernumber':this.radio}).then(res => {
        console.log(res);

        if(res.code==1){
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }


      });


    },




    handleInput(val){
      this.keywords = val
      // console.log(this.keywords);
      this.recordapi();
    },
    // ss(){
    //   this.handleInput();
    // },
    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },
    // 分类
    type:function(e){
      this.loading = true,
     console.log(e);
     this.keywords = '';
     this.typeid = e;

     this.recordapi();
    },
    radxz:function(e){
      console.log(e);
      this.radio = e;
    },





  }

 }
</script>
</strong>



// WEBPACK FOOTER //
// src/components/Index.vue